<script>
    import { createEventDispatcher } from 'svelte';
    import { guidV4 } from '@itslearning/atlas/generate/guid';

    const dispatch = createEventDispatcher();
    /** @type {string} */
    export let label;
    /** @type {string} */
    export let id = 'rnd' + Math.random().toString(36);
    /** @type {string} */
    export let value = undefined;
    /** @type {string} */
    export let name = undefined;
    /** @type {boolean} */
    export let hasError = false;
    /** @type {string} */
    export let errorMessage = undefined;
    /** @type {boolean} */
    export let required = false;
    /** @type {boolean} */
    export let disabled = false;
    /** @type {string} */
    export let description = undefined;
    /** @type {string} */
    export let describedBy = undefined;
    /** @type {'left' | 'top'} */
    export let labelPosition = 'top';
    /** @type {boolean} */
    export let labelHidden = false;

    describedBy =
        description && !describedBy
            ? 'prom-checkbox__information_id-' + guidV4()
            : describedBy;

    $: labelText = label || console.warn('Select label text was not supplied!');
    $: hasErrorClass = hasError ? 'prom-select--has-error' : '';
</script>

<div class="prom-select">
    <div class="prom-select__wrapper {hasErrorClass}" class:prom-select__wrapper--label-left={labelPosition === 'left'}>
        <label for="{id}" class:screen-reader={labelHidden} class="prom-select__label-text">
            {labelText}

            {#if required}
                <span aria-hidden="true" class="prom-select__required-star">*</span>
            {/if}
        </label>
        <div class="prom-select__select-container">
            <select
                id="{id}"
                bind:value="{value}"
                name="{name}"
                required="{required}"
                disabled="{disabled}"
                class="prom-select__select"
                on:change="{() => dispatch('change', value)}"
                aria-describedby="{describedBy}">
                <slot />
            </select>
            <div class="prom-select__focus-wrapper"></div>
        </div>
    </div>

    {#if hasError && errorMessage}
        <div id="{describedBy}" class="prom-error-message">{errorMessage}</div>
    {:else if description}
        <div id="{describedBy}" class="prom-select__description"
            >{description}</div>
    {/if}
</div>
